import { computed, inject, runInInjectionContext, Signal } from '@angular/core';
import { SettingsService } from './services/settings.service';

import { EnvironmentInjector } from '@angular/core';
import { SettingsModel } from './models/settings.module';

let _appSettings: Signal<SettingsModel> | null = null;

export function getAppSettings(
  envInjector: EnvironmentInjector,
): Signal<SettingsModel> {
  if (!_appSettings) {
    _appSettings = runInInjectionContext(envInjector, () => {
      const settingsService = inject(SettingsService);
      return settingsService.settings; // ✅ Already a signal<SettingsModel>
    });
  }

  return _appSettings;
}

export const appSettings = () => getAppSettings(inject(EnvironmentInjector));
